import tw from "twin.macro"

const CardBase = tw.div`cursor-pointer shadow group-hocus:(scale-small shadow-hover) (transition-card duration-300)`

export default CardBase
